var body_top_styles = {
  body_top: {
    display: "flex",
    height: "100%",
    maxHeight: "64px",
    flexDirection: "column" as const,
    alignItems: "flex-start",
    gap: "4px",
    alignSelf: "stretch",
    width: "100%"
  },
  username: {
    display: "flex",
    flexDirection: "column" as const,
    justifyContent: "center",
    flex: "1 0 0",
    alignSelf: "stretch",
    color: "var(--Black---1000, #191924)",
    fontFamily: "Montserrat",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "20px",
  },
  headline: {
    display: "flex",
    flexDirection: "column" as const,
    justifyContent: "center" as const,
    flex: "1 0 0",
    alignSelf: "stretch",
    color: "var(--Black---1000, #191924)",
    fontFamily: "Montserrat",
    fontSize: "32px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "40px",
    width: "500px",
  },
};

export default body_top_styles;